import ProviderBase from './ProviderBase';

const   BaseEndpoint = '/location',
        ByNameEndpoint = '/location/byname/{0}';

class LocationProvider extends ProviderBase {    
    constructor() {
        super(BaseEndpoint);
    }

    getOne(id, includes) {
        return this._getOne(id, includes);
    }

    getOneByName(canonicalName) {
        return this.api.get(ByNameEndpoint.format(canonicalName));
    }

    getAll(filter) {
        return this._getAll(filter);
    }

    post(data) {
        return this._post(data);
    }

    put(id, data) {
        return this._put(id, data);
    }

    patch(id, data) {
        return this._patch(id, data);
    }

    delete(id) {
        return this._delete(id);
    }
}

LocationProvider.ArLocationCode = "AccountsReceivable";

export default LocationProvider;